/*eslint-disable*/
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Chip,
  FormControl,
  Grid,
  Icon,
  Typography,
  withStyles
} from '@material-ui/core';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { createUploadLink } from 'apollo-upload-client';
import avatar from 'assets/img/faces/avatar1.jpg';
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import FormInput from 'components/Wrappers/materialUIWrappers/components/FormInput';
import { fileUploadServerPath } from 'constants.js';
import GetIdInformation, { idNumberValid } from 'helpers/GetIdInformation';
import { dateValid, isEmptyOrSpaces } from 'helpers/ValidationHelpers';
import _ from 'lodash';
import React from 'react';
import Dropzone from 'react-dropzone';
import { change, Field } from 'redux-form';
import store from 'store';
import { astuteIn, quoteIn } from './FieldIndicators.jsx';
import coi_options from './coi_options';
import CC_clientOccForm_EliteWealth from "./CC_clientOccForm_EliteWealth";

const client = new ApolloClient({
  link: createUploadLink({ uri: fileUploadServerPath }),
  cache: new InMemoryCache()
});

const required = value => (value ? undefined : 'Required');

const requiredDropdown = value => {
  if (!value || value === 'validationError') {
    return 'Required';
  }

  return undefined;
};

const charMin2 = value => {
  if (value === undefined) return undefined;

  if (value.length < 2) return 'Must be at least 2 characters';

  return undefined;
};

const styles = () => ({});

class CC_clientForm_EliteWealth extends React.Component {
  state = {
    idValid: false,
    idChanged: false
  };

  componentDidMount() {
    this.props.scrollMeBar();
  }

  idChanged = value => {
    let x = GetIdInformation(value);
    if (x === 'error') {
      return;
    }
    store.dispatch(change('client', 'dateOfBirth', x.dob));
    store.dispatch(change('client', 'gender', x.gender));
    this.props.dobChanged(x.dob);
  };

  genderChanged(gender) {
    var title = _.get(store.getState().form.client, 'values.title', null);

    if (title && gender) {
      store.dispatch(change('client', 'title', gender === 'F' ? 'MS' : 'MR'));
    }

    this.forceUpdate();
  }

  render() {
    const validate = [];
    validate.push(required);

    let marriedOptions = null;

    let idOptions = null;

    var gender = _.get(store.getState().form.client, 'values.gender', null);
    var hideFemaleOption = !gender ? false : gender === 'M' ? true : false;
    var hideMaleOption = !gender ? false : gender === 'F' ? true : false;

    let womanOptions = [
      { value: 'MRS', displayValue: 'MRS', hidden: hideFemaleOption },
      { value: 'MISS', displayValue: 'MISS', hidden: hideFemaleOption }
    ];

    if (
      !hideFemaleOption &&
      store.getState().form.client &&
      store.getState().form.client.values
    ) {
      let mStatus = store.getState().form.client.values.maritalStatus;
      if (mStatus && mStatus !== 'validationError') {
        if (mStatus === 'Married') {
          womanOptions = [
            {
              value: 'MRS',
              displayValue: 'MRS',
              hidden: hideFemaleOption
            }
          ];
        } else {
          womanOptions = [
            {
              value: 'MISS',
              displayValue: 'MISS',
              hidden: hideFemaleOption
            }
          ];
        }
      }
    }

    let titleOptions = [
      {
        value: 'validationError',
        displayValue: 'Please select'
      },
      { value: 'MR', displayValue: 'MR', hidden: hideMaleOption },
      ...womanOptions,
      {
        value: 'MS',
        displayValue: 'MS',
        hidden: hideFemaleOption
      },
      { value: 'ADV', displayValue: 'ADV' },
      { value: 'DR', displayValue: 'DR' },
      { value: 'JUDG', displayValue: 'JUDGE' },
      { value: 'PROF', displayValue: 'PROF' }
    ];

    if (this.props.saCitizen) {
      idOptions = (
        <React.Fragment>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <Field
                component={FormInput}
                checkValidation={this.props.checkValidation}
                name='said'
                label='South African ID'
                validate={[idNumberValid]}
                onChange={e => this.idChanged(e.target.value)}
              />
            </FormControl>
          </Grid>
        </React.Fragment>
      );
    } else {
      idOptions = (
        <React.Fragment>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <Field
                component={FormInput}
                checkValidation={this.props.checkValidation}
                name='passportNumber'
                label='Pasport number'
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <Field
                component={FormDropdown}
                options={coi_options}
                checkValidation={this.props.checkValidation}
                name='countryOfIssue'
                label='Pasport Country Of Issue'
              />
            </FormControl>
          </Grid>
        </React.Fragment>
      );
    }

   

    const age = _.get(store.getState().form, 'client.values.age', null);

    return (
      <div className='contentWithStepper'>
        <Card>
          <CardHeader
            title={this.props.firstName + ' ' + this.props.lastName}
            style={{ textAlign: 'center' }}
          />
          <CardContent>
            <Grid container spacing={24}>
              <Grid item xs={12} sm={6} style={{ display: 'flex' }}>

                <FormControl fullWidth>
                  <Field
                    component={FormDropdown}
                    checkValidation={this.props.checkValidation}
                    label='Title *'
                    name='title'
                    options={titleOptions}
                    isrequired={true}
                    validate={[requiredDropdown]}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} style={{ display: 'flex' }}>
                <FormControl fullWidth>
                  <Field
                    component={FormInput}
                    isrequired={true}
                    validate={[required, charMin2]}
                    checkValidation={this.props.checkValidation}
                    name='firstName'
                    label='First name *'
                    onChange={e => this.props.changeFirstName(e.target.value)}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} style={{ display: 'flex' }}>
                <FormControl fullWidth>
                  <Field
                    component={FormInput}
                    isrequired={true}
                    validate={[required, charMin2]}
                    checkValidation={this.props.checkValidation}
                    name='lastName'
                    label='Surname *'
                    onChange={e => this.props.changeLastName(e.target.value)}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} style={{ display: 'flex' }}>
                <FormControl fullWidth>
                  <Field
                    label='Date of birth'
                    name={'dateOfBirth'}
                    component={FormInput}
                    placeholder={'DD/MM/YYYY'}
                    validate={[dateValid]}
                    onChange={e => this.props.dobChanged(e.target.value)}
                  />
                </FormControl>
                {isEmptyOrSpaces(age) ? (
                  <div style={{ height: '47px' }} />
                ) : (
                  <div className='ageBlock'>
                    <Typography variant='caption'>Age</Typography>
                    <Typography>{age}</Typography>
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={6} style={{ display: 'flex' }}>
                <FormControl fullWidth>
                  <Field
                    component={FormDropdown}
                    label='Gender'
                    name='gender'
                    options={[
                      {
                        value: 'validationError',
                        displayValue: 'Please select'
                      },
                      { value: 'M', displayValue: 'Male' },
                      { value: 'F', displayValue: 'Female' }
                    ]}
                    onValueChange={e => this.genderChanged(e)}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} style={{ display: 'flex' }}>
                <FormControl fullWidth>
                  <Field
                    component={FormDropdown}
                    checkValidation={this.props.checkValidation}
                    label='Smoker?'
                    name='smoker'
                    options={[
                      {
                        value: 'validationError',
                        displayValue: 'Please select'
                      },
                      { value: 'N', displayValue: 'No' },
                      { value: 'Y', displayValue: 'Yes' }
                    ]}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} style={{ display: 'flex' }}>
                <FormControl fullWidth>
                  <Field
                    component={FormDropdown}
                    checkValidation={this.props.checkValidation}
                    label='Marital Status'
                    name='maritalStatus'
                    options={[
                      {
                        value: 'validationError',
                        displayValue: 'Please select'
                      },
                      { value: 'Single', displayValue: 'Single' },
                      { value: 'Divorced', displayValue: 'Divorced' },
                      { value: 'Married', displayValue: 'Married' },
                      { value: 'Widowed', displayValue: 'Widowed' }
                    ]}
                    onValueChange={e => this.props.maritalChangeHandler(e)}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <br />
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default withStyles(styles)(CC_clientForm_EliteWealth);



// WEBPACK FOOTER //
// ./src/views/Clients/components/CC_clientForm_EliteWealth.jsx